(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gl-customer-reviews"] && !Shopify.designMode) return;
  try {
    
if (!window.glReviewPhotosReady) {
  window.glReviewPhotosReady = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-review-photo]');
    if (link) {
      const dialog = link.closest('.gl-reviews').querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      const image = dialog.querySelector('img');
      image.src = link.href;
      image.alt = link.querySelector('img').alt;
      dialog.showModal();
      dialog.addEventListener('close', () => link.focus(), { once: true });
    }
    const dialog = event.target.closest('.gl-reviews__dialog');
    if (dialog && (event.target.closest('.gl-reviews__close') || event.target === dialog)) dialog.close();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('[data-gl-scroll-header]').forEach(header => {
      if (header.dataset.scrollReady) return;
      header.dataset.scrollReady = 'true';
      const section = header.closest('.shopify-section');
      if (!section) return;
      const controller = new AbortController();
      const mobile = window.matchMedia('(max-width: 1080px)');
      let lastY = Math.max(0, window.scrollY);
      let distance = 0;
      let direction = 0;
      let pending = false;
      const show = () => section.classList.remove('gl-scroll-hidden');
      const update = () => {
        pending = false;
        const y = Math.max(0, Math.min(window.scrollY, document.documentElement.scrollHeight - window.innerHeight));
        const delta = y - lastY;
        lastY = y;
        if (!mobile.matches || y <= section.offsetHeight || header.contains(document.activeElement) || header.querySelector('[aria-expanded="true"], details[open]')) {
          show();
          distance = 0;
          return;
        }
        const nextDirection = Math.sign(delta);
        if (nextDirection !== direction) distance = 0;
        direction = nextDirection;
        distance += Math.abs(delta);
        if (distance >= 8) {
          section.classList.toggle('gl-scroll-hidden', direction > 0);
          distance = 0;
        }
      };
      window.addEventListener('scroll', () => {
        if (!pending) { pending = true; requestAnimationFrame(update); }
      }, { passive: true, signal: controller.signal });
      header.addEventListener('focusin', show, { signal: controller.signal });
      mobile.addEventListener('change', update, { signal: controller.signal });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target === section) controller.abort();
      }, { signal: controller.signal });
      update();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-review-submit"] && !Shopify.designMode) return;
  try {
    
if (!window.glReviewSubmitBound) {
 window.glReviewSubmitBound = true;
 document.addEventListener('click', event => {
  const link = event.target.closest('[data-gl-review-open]');
  if (link) {
   const dialog = link.closest('.gl-submit').querySelector('dialog');
   if (!dialog || typeof dialog.showModal !== 'function') return;
   event.preventDefault();
   dialog.querySelector('iframe').src = link.href;
   dialog.showModal();
   dialog.addEventListener('close', () => { dialog.querySelector('iframe').removeAttribute('src'); link.focus(); }, {once:true});
  }
  const close = event.target.closest('[data-gl-review-close]');
  if (close) close.closest('dialog').close();
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
